const exported = {
  CUSTOM_ROLES: 'custom-roles',
  MONITOR: 'monitor',
  REACH: 'reach',
  DISBURSEMENTS: 'disbursements',
  ORG: 'org',
  ORG_LEARNERS: 'learners',
  OVERVIEW: 'overview',
  EXPORTS: 'exports',
  PROMOTIONS: 'promotions',
  SETTINGS: 'settings',
  STAFF: 'staff',
  INSTITUTION_ASSETS: 'institution-assets',
  COURSE_MARKETING: 'course-marketing',
  SPECIALIZATION_MARKETING: 'specialization-marketing',
  SPECIALIZATION_SUMMARY: 'specialization-summary',
  SPECIALIZATION_CHANNELS: 'specialization-channels',
  SPECIALIZATION_CAMPAIGNS: 'specialization-campaigns',
  SPECIALIZATION_PROMOTION: 'specialization-promotions',
  SPECIALIZATION_ANALYTICS: 'specialization-analytics',
  SUMMARY: 'summary',
  CHANNELS: 'channels',
  CAMPAIGNS: 'campaigns',
  COURSE_VIEW: 'course-view',
  PROMOTION_VIEW: 'promotion-view',
  EXTERNAL_APPS: 'external-apps',
  MANAGE_EXTERNAL_APPS: 'manage',
  DISCOVER_EXTERNAL_APPS: 'discover',
  UNIVERSITY_ASSETS: 'university-assets',
};

export default exported;

export const {
  CUSTOM_ROLES,
  MONITOR,
  REACH,
  DISBURSEMENTS,
  ORG,
  ORG_LEARNERS,
  OVERVIEW,
  EXPORTS,
  PROMOTIONS,
  PROMOTION_VIEW,
  SETTINGS,
  STAFF,
  INSTITUTION_ASSETS,
  COURSE_MARKETING,
  SPECIALIZATION_MARKETING,
  SPECIALIZATION_SUMMARY,
  SPECIALIZATION_CHANNELS,
  SPECIALIZATION_CAMPAIGNS,
  SPECIALIZATION_PROMOTION,
  SPECIALIZATION_ANALYTICS,
  SUMMARY,
  CHANNELS,
  COURSE_VIEW,
  CAMPAIGNS,
  EXTERNAL_APPS,
  MANAGE_EXTERNAL_APPS,
  DISCOVER_EXTERNAL_APPS,
  UNIVERSITY_ASSETS,
} = exported;
